import api from './api';

export const getSubscribers = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/newsletter/subscribers?${queryParams}`);
  return response.data;
};

export const sendNewsletter = async (data) => {
  const response = await api.post('/newsletter/send', data);
  return response.data;
};

export const sendPromotionalEmail = async (data) => {
  const response = await api.post('/newsletter/promotional', data);
  return response.data;
};

export const unsubscribeUser = async (email) => {
  const response = await api.post('/newsletter/unsubscribe', { email });
  return response.data;
};
